import { BsTwitter } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import { AiFillGithub } from "react-icons/ai";
import { FaLinkedin } from "react-icons/fa";


// Navbar links
const navbar_links = [
  "home",
  "about",
  "work",
  "skills",
  // "testimonial",
  "contact",
];

// Contact links
const contact_links = {
  email: "contactme@micael.com",
  phone: "+92 334 1510432",
};

// Social links
const social_links = [
  {
    name: "LinkedIn",
    icon: <FaLinkedin />,
    url: "https://www.linkedin.com/in/ahmadalisheikhh/",
  },
  {
    name: "Github",
    icon: <AiFillGithub />,
    url: "https://github.com/Ahmad-sheikh1",
  },
];

// Source code
const source_code = "https://github.com/Ahmad-sheikh1";

// links
const links = {
  navbar_links,
  contact_links,
  social_links,
  source_code,
};

export default links;
